import { ShelterAttGridRoutingModule } from './shelter-att-grid-routing.module';
import { CommonModule } from '@angular/common';
import { AgGridModule } from '@ag-grid-community/angular';
import { NgModule } from '@angular/core';
import { NvButtonModule } from '../../../../nvps-libraries/design/nv-button/nv-button.module';
import { NvIconButtonModule } from '../../../../nvps-libraries/design/nv-icon-button/nv-icon-button.module';
import { AttendanceGridService } from './services/attendance-grid.service';
import { ShelterAttGridComponent } from './shelter-att-grid.component';
import { NgRouterNavigationService } from 'Src/ng2/school/lists/services/list-navigation/ng-router-list-navigation.service';

@NgModule({
  declarations: [ShelterAttGridComponent],
  imports: [
    AgGridModule.withComponents([]),
    CommonModule,
    NvButtonModule,
    NvIconButtonModule,
    ShelterAttGridRoutingModule,
  ],
  exports: [],
  providers: [AttendanceGridService, NgRouterNavigationService],
})
export class ShelterAttGridModule {}
